<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="提示"
      @ok="handleSubmit"
    >
      <span>确定发送结算提醒吗？请注意客户支付情况。</span>
      <a-form
        class="custom-compact-form"
        style="margin-top:50px;"
        :form="form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 15 }"
        @submit="handleSubmit"
      >
        <!--        <a-form-item>-->
        <!--          <a-textarea-->
        <!--            v-decorator="['remark', {-->
        <!--              normalize: this.$lodash.trim,-->
        <!--              rules: [-->
        <!--                { max: 50, message: '最多50个字符' },-->
        <!--              ]-->
        <!--            }]"-->
        <!--          />-->
        <!--        </a-form-item>-->

      </a-form>
    </a-modal>
  </div>
</template>

<script>

import { sendPaymentReminder } from '@/api/order'

export default {
  name: 'SendPaymentReminder',
  components: {
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    unpaidFee: {
      type: Number,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'send_payment_reminder' }),
      submitting: false,
      data: {}
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }
      if (this.unpaidFee <= 0) {
        this.$warning({
          title: '剩余应付金额为0，无法向小程序用户发送订单支付提醒，请核对结算详情。',
          content: ''
        })
        return
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          this.submitting = true
          sendPaymentReminder(Object.assign({ order_id: this.id }, values)).then((res) => {
            if (res.code === 0) {
              // 关闭模态框
              this.isShow = false
              // 告知父组件已完成
              this.$emit('completed')
            }
            this.submitting = false
          })
        }
      })
    }
  }
}
</script>
